import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Paper as Paper$1 } from '@mui/material';
var _excluded = ["className", "sx"];

var useStyles = function useStyles() {
  return {
    root: {
      padding: 2
    }
  };
};

var Paper = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      sx = _ref.sx,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useStyles = useStyles(),
      root = _useStyles.root;

  var sxProps = [root, sx];
  return /*#__PURE__*/React.createElement(Paper$1, _extends({
    ref: ref,
    className: className,
    sx: sxProps
  }, restProps));
});
Paper.defaultProps = {
  elevation: 4,
  square: false
};
Paper.displayName = 'Paper';
export { Paper };